/**
 * Refactored by mariushirjanu on 28/07/2020.
 */
import * as _ from 'underscore';
import { ICountry, INamedObject } from '../../../../../type_definitions/datatypes';
import { GaEventService } from '../../../../shared/services/ga-event.service';
import { IOrderContext, ProcurementType } from '../order-entry-data.service';
import { Injectable } from '@angular/core';
import {
  EVENT_ORDER_BP_LIST_UPDATED,
  EVENT_ORDER_BP_SELECTION_UPDATED,
  EVENT_ORDER_CONTEXT_UPDATED,
  EVENT_ORDER_COUNTRY_LIST_UPDATED,
  EVENT_ORDER_COUNTRY_SELECTION_UPDATED,
  EVENT_ORDER_LOADING_BPS,
  EVENT_ORDER_LOADING_CONTEXT,
  EVENT_ORDER_LOADING_COUNTRIES,
  EVENT_ORDER_WEBSHOP_LIST_UPDATED,
  EVENT_ORDER_WEBSHOP_SELECTION_UPDATED
} from '../../../../shared/app-events';

@Injectable()
export class OrderEntryWebshopService {
  private _title:string;
  private _possibleShops:INamedObject[];
  private _possibleCountries:ICountry[];
  private _possibleBPs:INamedObject[];
  private _shopContext:IOrderContext;
  private _selectedShop:INamedObject;
  private _selectedCountry:ICountry;
  private _selectedBP:INamedObject;
  private _loadingContext:boolean;
  private _loadingCountries:boolean;
  private _loadingBPs:boolean;
  private _testMode:boolean;
  private _bpOutdated:number;
  private _workflowType:string;

  constructor(
    private gaEventService:GaEventService
  ) {
    /***/
  }

  public set possibleShops(shops:INamedObject[]) {
    this._possibleShops = shops;
    this.gaEventService.sendMessage(EVENT_ORDER_WEBSHOP_LIST_UPDATED, shops);
  }
  public get possibleShops():INamedObject[] {
    return this._possibleShops;
  }
  
  public set possibleCountries(countries:ICountry[]) {
    this._possibleCountries = countries;
    this.gaEventService.sendMessage(EVENT_ORDER_COUNTRY_LIST_UPDATED, countries);
  }
  public get possibleCountries():ICountry[] {
    return this._possibleCountries;
  }

  public set possibleBPs(bps:INamedObject[]) {
    this._possibleBPs = bps;
    this.gaEventService.sendMessage(EVENT_ORDER_BP_LIST_UPDATED, bps);
  }
  public get possibleBPs():INamedObject[] {
    return this._possibleBPs;
  }

  public set shopContext(shopContext:IOrderContext) {
    if(!_.isEqual(this._shopContext, shopContext)) {
      this._shopContext = shopContext;
      this.gaEventService.sendMessage(EVENT_ORDER_CONTEXT_UPDATED, shopContext);
    }
  }
  public get shopContext():IOrderContext {
    return this._shopContext;
  }

  public set loadingContext(loadingContext:boolean) {
    this._loadingContext = loadingContext;
    this.gaEventService.sendMessage(EVENT_ORDER_LOADING_CONTEXT, loadingContext);
  }
  public get loadingContext():boolean {
    return this._loadingContext;
  }

  public set selectedShop(shop:INamedObject) {
    if(!_.isEqual(this._selectedShop, shop)){
      this._selectedShop = shop;
      this.gaEventService.sendMessage(EVENT_ORDER_WEBSHOP_SELECTION_UPDATED, shop);
    }
  }
  public get selectedShop():INamedObject {
    return this._selectedShop;
  }

  public set selectedCountry(country:ICountry) {
    if(!_.isEqual(this._selectedCountry, country)) {
      this._selectedCountry = country;
      this.gaEventService.sendMessage(EVENT_ORDER_COUNTRY_SELECTION_UPDATED, country);
    }
  }
  public get selectedCountry():ICountry {
    return this._selectedCountry;
  }

  public set selectedBP(bp:INamedObject) {
    if(!_.isEqual(this._selectedBP, bp)) {
      this._selectedBP = bp;
      this.gaEventService.sendMessage(EVENT_ORDER_BP_SELECTION_UPDATED, bp);
    }
  }
  public get selectedBP():INamedObject {
    return this._selectedBP;
  }

  public set loadingCountries(loadingCountries:boolean) {
    this._loadingCountries = loadingCountries;
    this.gaEventService.sendMessage(EVENT_ORDER_LOADING_COUNTRIES, loadingCountries);
  }
  public get loadingCountries():boolean {
    return this._loadingCountries;
  }

  public set loadingBPs(loadingBPs:boolean) {
    this._loadingBPs = loadingBPs;
    this.gaEventService.sendMessage(EVENT_ORDER_LOADING_BPS, loadingBPs);
  }
  public get loadingBPs():boolean {
    return this._loadingBPs;
  }

  public get title():string {
    return this._title;
  }
  public set title(title:string) {
    this._title = title;
  }

  public get workflowType():string {
    return this._workflowType;
  }
  public set workflowType(workflowType:string) {
    this._workflowType = workflowType;
  }

  public get bpOutdated():number {
    return this._bpOutdated;
  }
  public set bpOutdated(bpOutdated:number) {
    this._bpOutdated = bpOutdated;
  }

  public get testMode():boolean {
    return this._testMode;
  }
  public set testMode(testMode:boolean) {
    this._testMode = testMode;
  }

  public get showOnlyLeasingPrice():boolean {
    return this.shopContext?.hidePrices && this.shopContext?.defaultProcurementType === ProcurementType.LEASE;
  }

  // !!! when making changes in the class make sure you adjust this method
  public clear():void {
    const PROP_TO_EXCLUDE:string[] = ['gaEventService'];
    for (const key in this) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.hasOwnProperty(key) && !_.contains(PROP_TO_EXCLUDE, key)) {
        this[ key ] = undefined;
      }
    }
  }
}